import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { SharedEnv } from './environment.type';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  #environmentData$ = new ReplaySubject<SharedEnv>(1);
  environmentData$ = this.#environmentData$.asObservable();

  setEnvironmentData(input: SharedEnv) {
    this.#environmentData$.next(input);
  }
}
